import unescape from 'lodash.unescape'

// File types ("file groups") can be organized into folders by naming them with
// a ">" separator, e.g. "Design > Drawings for Installation" → folder "Design".
// No data migration is required: admins simply add ">" to the relevant names.

// Sentinel for file types that have no ">" in their name.
export const FILE_FOLDER_OTHER = '__other__'

const FOLDER_SEPARATOR = '>'

// The backend currently returns file-group names HTML-escaped (">" comes back as
// "&gt;"). Always unescape before parsing or displaying a group name.
// TODO: Verify API usage — backend should stop double-escaping the name server-side.
export function unescapeGroupName(name?: string | null): string {
  return unescape(name ?? '')
}

// Returns the folder label (trimmed text before the first ">"), or null when the
// name has no ">" (i.e. it belongs to the "Other" bucket).
export function getFolderName(name?: string | null): string | null {
  const unescaped = unescapeGroupName(name)
  const separatorIndex = unescaped.indexOf(FOLDER_SEPARATOR)
  if (separatorIndex === -1) {
    return null
  }
  const folder = unescaped.slice(0, separatorIndex).trim()
  return folder || null
}

type FileGroupLike = { label?: string | null, name?: string | null }

// Distinct, alphabetically-sorted folder names across all provided file groups.
// Accepts both option-shaped objects ({ label }) and raw groups ({ name }).
export function getFolderNames(groups: FileGroupLike[] = []): string[] {
  const folders = new Set<string>()
  groups.forEach((group) => {
    const folder = getFolderName(group.label ?? group.name)
    if (folder) {
      folders.add(folder)
    }
  })
  return [...folders].sort((a, b) => a.localeCompare(b))
}
